module.exports = __webpack_public_path__ + "img/c1.d422b73b.png";